export class RenderLock {
  constructor() {
    this._locks = new Map();
  }

  isLocked() {
    return this._locks.size > 0;
  }

  add(key = 'default') {
    const count = this._locks.get(key) || 0;
    this._locks.set(key, count + 1);
  }

  remove(key = 'default') {
    if (!this._locks.has(key)) {
      return;
    }

    const count = this._locks.get(key);

    if (count <= 1) {
      this._locks.delete(key);
      return;
    }

    this._locks.set(key, count - 1);
  }

  has(key) {
    return this._locks.has(key);
  }

  getCount(key) {
    return this._locks.get(key) || 0;
  }

  getActiveLocks() {
    return Array.from(this._locks.entries()).map(([key, count]) => ({
      key,
      count,
    }));
  }

  clear(key) {
    if (key) {
      this._locks.delete(key);
      return;
    }

    this._locks.clear();
  }

  total() {
    let total = 0;

    for (const count of this._locks.values()) {
      total += count;
    }

    return total;
  }
}
